import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    container: {
        width: '100%',
        padding: '20px',
        backgroundColor: '#1c1f24',
        borderRadius: '10px',
    },
    title: {
        fontSize: '2rem',
        fontWeight: 700,
        color: '#fff',
        marginBottom: '10px',
    },
    subtitle: {
        color: '#9f6ffb',
        fontFamily: 'Inter, sans-serif',
        fontSize: '18px',
        marginBottom: '30px',
    },
    searchBox: {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#2a2d35',
        borderRadius: '8px',
        border: '1px solid #333',
        padding: '4px 12px',
        width: '100%',
    },
    iconButton: {
        color: '#9f6ffb',
    },
    iconButtonSearch: {
        color: '#fff',
    },
    inputBase: {
        color: '#fff',
        marginLeft: 8,
        flex: 1,
        fontSize: '14px',
    },
    actionButton: {
        padding: '6px 14px',
        backgroundColor: '#9f6ffb',
        color: '#fff',
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: 500,
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
            backgroundColor: '#7c3aed',
        },
    },
    cancelButton: {
        backgroundColor: '#000000',
        color: '#ffffff',
        border: '1px solid #000000',
        marginRight: '20px',
        transition: 'all 0.3s ease',
        '&:hover': {
            backgroundColor: '#333333',
            border: '1px solid #666',
            transform: 'translateY(-2px)',
            boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
        },
        '&:disabled': {
            backgroundColor: '#666',
            color: '#ccc',
        }
    },


    accionesButton: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '10px 18px',
        border: 'none',
        borderRadius: '6px',
        fontWeight: 600,
        fontSize: '14px',
        cursor: 'pointer',
        transition: 'background 0.2s ease',
        border: '0.5px solid #9F6FFB',
    },
    catalogoSubtitulo: {
        color: '#9f6ffb',
        fontFamily: 'Inter, sans-serif',
        fontSize: '18px',
    },
    modalDialog: {
        '& .MuiDialog-paper': {
            backgroundColor: '#1c1f24',
            borderRadius: '12px',
            border: '1px solid #333',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
        },
    },
    modalTitle: {
        //backgroundColor: '#2a2d35',
        color: '#ffffff',
        borderBottom: '1px solid #333',
        padding: '20px 24px',
        '& .MuiTypography-root': {
            fontSize: '20px',
            fontWeight: 600,
            color: '#ffffff',
        },
    },
    card: {
        width: "649px",
        height: "296px",
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    modalContent: {
        backgroundColor: '#1c1f24',
        padding: '24px',
        '& .MuiDialogContent-root': {
            padding: 0,
        },
    },
    modalActions: {
        backgroundColor: '#2a2d35',
        borderTop: '1px solid #333',
        padding: '16px 24px',
        gap: '12px',
    },
    backdrop: {
        zIndex: 1400, // Aumentar el z-index para estar por encima del modal
        color: '#fff',
        backgroundColor: 'rgba(0, 0, 0, 0.8)', // Agregar fondo semi-transparente
    },
    spinner: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px',
    },
    spinnerText: {
        color: '#ffffff',
        fontSize: '16px',
        fontWeight: 500,
    },
    buttonCrear:
    {
        textTransform: 'none',
        borderRadius: '4px',
        border: `0.5px solid ${theme.palette.colors.violet[300]}`,
        background: `${theme.palette.colors.grey[500]}`,
        color: `${theme.palette.colors.white}`,
        fontSize: '14px',
        width: '230px',
        cursor: 'pointer',
        '&:hover': {
            background: '#9F6FFB',
            border: '1px solid #9F6FFB',
        }
    },
    catalogsTable: {
        '& .MuiTableHead-root .MuiTableCell-head .MuiTypography-root': {
            fontSize: '14px !important',
        },
        '& .MuiIconButton-root': {
            padding: '0px !important',
        },
    },
    actionIcon: {
        fontSize: '20px !important',
    },
    tooltipRuleMessage: {
        backgroundColor: '#2a2d35',
        color: '#fff',
        fontSize: '13px',
        fontWeight: 500,
        padding: '12px 16px',
        maxWidth: 380,
        border: '1px solid #9f6ffb',
        borderRadius: '8px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.4)',
        lineHeight: 1.5,
    },
    tooltipRuleArrow: {
        color: '#2a2d35',
    },
}));
